import { render, staticRenderFns } from "./CrowdShooting.vue?vue&type=template&id=54ecc1ec&scoped=true&"
import script from "./CrowdShooting.vue?vue&type=script&lang=js&"
export * from "./CrowdShooting.vue?vue&type=script&lang=js&"
import style0 from "./CrowdShooting.vue?vue&type=style&index=0&id=54ecc1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ecc1ec",
  null
  
)

export default component.exports